import * as Actions from "../actions/_ActionTypes";
import * as Pre from "../actions/_PreActionNames";
const initState = {
  widgets: [],
};

const AppWidgetReducer = (state = initState, action) => {
  const _state = { ...state };

  if (action.socket && action.socket.send) {
    // leave request to handle by server
    if (action.type.indexOf(Pre.APP_WIDGET) == 0) {
      // _state.isLoading = true;
    }
    return _state;
  }
  var parsedData = null;
  if (action.payload && action.payload.data) {
    parsedData = JSON.parse(action.payload.data);
  }

  // else apply locally
  switch (action.type) {
    case Pre.APP_WIDGET + Actions.ALL:
      if (parsedData && Array.isArray(parsedData)) {
        _state.widgets = parsedData;
      }
      _state.isLoading = false;
      break;
    case Pre.APP_WIDGET + Actions.CLEAR:
      _state.widgets = [];
      break;
    case Actions.CLEAR_CACHE:
    case Actions.LOGOUT:
      _state.widgets = [];
      break;
  }
  return _state;
};

export default AppWidgetReducer;
